import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IStoreMovementFilterSet } from '../../shared/models/inventory/store-movement-filter-set';
import { IStoreMovementItem } from '../../shared/models/inventory/store-movement-item';
import { IProductStoreListItem } from '../../shared/models/inventory/product-store-list-item';
import { MovementType } from '../../shared/models/inventory/movement-type-enum';

type ViewMode = 'list' | 'grid';

interface IProductFilterSet {
  search: string;
  viewMode: ViewMode;
}

interface ISStoreProductState {
  movementFilterSet?: IStoreMovementFilterSet;
  storeMovement?: IStoreMovementItem;
  productsStore: IProductStoreListItem[];
  productFilterSet: IProductFilterSet;
  refetchStores?: boolean;
  refetchStoreDetail?: boolean;
}

const initialState: ISStoreProductState = {
  movementFilterSet: {
    search: '',
    page: 1,
    size: 10,
    type: MovementType.Internal,
  },
  storeMovement: undefined,
  productsStore: [],
  productFilterSet: {
    search: '',
    viewMode: 'list',
  },
  refetchStoreDetail: false,
  refetchStores: false,
};

const storeProductSlice = createSlice({
  name: 'storeProductSlice',
  initialState,
  reducers: {
    setMovementFilterSet: (state, action: PayloadAction<{ value?: IStoreMovementFilterSet }>) => {
      state.movementFilterSet = action.payload.value;
    },
    setStoreMovement: (state, action: PayloadAction<{ value?: IStoreMovementItem }>) => {
      state.storeMovement = action.payload.value;
    },
    setProductsStores: (state, action: PayloadAction<{ value?: IProductStoreListItem[] }>) => {
      state.productsStore = action.payload.value ?? [];
    },
    setProductFilterSet: (state, action: PayloadAction<Partial<IProductFilterSet>>) => {
      state.productFilterSet = { ...state.productFilterSet, ...action.payload };
    },
    setProductSearch: (state, action: PayloadAction<string>) => {
      state.productFilterSet.search = action.payload;
    },
    setProductViewMode: (state, action: PayloadAction<ViewMode>) => {
      state.productFilterSet.viewMode = action.payload;
    },
    resetProductFilters: (state) => {
      state.productFilterSet = initialState.productFilterSet;
    },
    setInitialState: (state) => {
      state.movementFilterSet = initialState.movementFilterSet;
      state.productsStore = initialState.productsStore;
      state.productFilterSet = initialState.productFilterSet;
      state.refetchStoreDetail = initialState.refetchStoreDetail;
      state.refetchStoreDetail = initialState.refetchStoreDetail;
    },
    setRefetchStores: (state, action: PayloadAction<boolean>) => {
      state.refetchStores = action.payload;
    },
    setRefetchStoreDetail: (state, action: PayloadAction<boolean>) => {
      state.refetchStoreDetail = action.payload;
    },
  },
});

export const {
  setMovementFilterSet,
  setStoreMovement,
  setProductsStores,
  setProductFilterSet,
  setProductSearch,
  setProductViewMode,
  resetProductFilters,
  setInitialState,
  setRefetchStoreDetail,
  setRefetchStores,
} = storeProductSlice.actions;
const StoreProductReducer = storeProductSlice.reducer;
export default StoreProductReducer;
